// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"500":"b81cefbe","582":"b81cefbe","825":"b81cefbe"}[chunkId] + ".chunk.css";
};